import { render, staticRenderFns } from "./PublicProfileResume.vue?vue&type=template&id=2071b34a&"
import script from "./PublicProfileResume.vue?vue&type=script&lang=js&"
export * from "./PublicProfileResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports